module.exports = __webpack_public_path__ + "static/img/1.2e44fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/1.png
// module id = 1pNw
// module chunks = 0